<template>
  <div>
    <!-- Hersteller-Auswahl -->
    <div class="form-group">
      <label>
        <p>Hersteller*</p>
        <select v-model="form.manufacturer" @change="updateModels" required>
          <option value="" disabled selected>Wähle den Hersteller</option>
          <option v-for="manufacturer in manufacturers" :key="manufacturer" :value="manufacturer">
            {{ manufacturer }}
          </option>
        </select>
      </label>
    </div>

    <!-- Typ-Auswahl -->
    <div class="form-group" v-if="models.length > 0">
      <label>
        <p>Model*</p>
        <select v-model="form.model" @change="updateVariants" required>
          <option value="" disabled selected>Wähle das Model</option>
          <option v-for="model in models" :key="model" :value="model">
            {{ model }}
          </option>
        </select>
      </label>
    </div>

    <!-- Varianten-Auswahl -->
    <div class="form-group" v-if="variants.length > 0">
      <label>
        <p>Variante*</p>
        <select v-model="form.variant" @change="updateBatterysize" required>
          <option value="" disabled selected>Wähle die Variante</option>
          <option v-for="variant in variants" :key="variant" :value="variant">
            {{ variant }}
          </option>
        </select>
      </label>
    </div>

    <!-- Batterie-Auswahl -->
    <div class="form-group" v-if="batterysizes.length > 0">
      <label>
        <p>Batteriegröße*</p>
        <select v-model="form.batterysize" required>
          <option value="" disabled selected>Wähle die Batteriegröße</option>
          <option v-for="batterysize in batterysizes" :key="batterysize" :value="batterysize">
            {{ batterysize }} kWh
          </option>
        </select>
      </label>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      form: {
        manufacturer: '',
        model: '',
        variant: '',
        batterysize: '' // Batteriekapazität
      },
      vehicles: {}, // Fahrzeugoptionen von der API
      manufacturers: [], // Herstellerliste
      models: [], // Modellauswahl basierend auf Hersteller
      variants: [], // Varianten basierend auf Modell
      batterysizes: [] // Aktuell ausgewählte Batteriekapazität
    }
  },
  methods: {
    reset () {
      this.form = {
        manufacturer: '',
        model: '',
        variant: '',
        batterysize: ''
      }
    },
    async loadVehicles () {
      try {
        // Fahrzeugdaten von der API laden
        const response = await axios.get('/api/getVehicles.php')
        console.log('Fahrzeugoptionen laden:', response.data)

        if (response.data.success) {
          this.vehicles = response.data.vehicles // Fahrzeugdaten in das `vehicles`-Objekt speichern
          this.manufacturers = Object.keys(this.vehicles) // Herstellerliste generieren
        } else {
          console.error('Fehler beim Laden der Fahrzeugoptionen:', response.data.error)
        }
      } catch (error) {
        console.error('Fehler beim API-Aufruf:', error)
      }
    },
    updateModels () {
      // Modelle basierend auf dem ausgewählten Hersteller laden
      if (this.form.manufacturer) {
        this.models = Object.keys(this.vehicles[this.form.manufacturer] || {})
        this.form.model = ''
        this.variants = []
        this.form.variant = ''
        this.form.batterysize = ''
      }
    },
    updateVariants () {
      // Varianten basierend auf dem ausgewählten Modell laden
      if (this.form.model) {
        const modelData = this.vehicles[this.form.manufacturer]?.[this.form.model] || {}
        this.variants = Object.keys(modelData)
        this.form.variant = ''
        this.form.batterysize = ''
      }
    },
    updateBatterysize () {
      // Batteriekapazität basierend auf der ausgewählten Variante laden
      if (this.form.variant) {
        const variantData = this.vehicles[this.form.manufacturer]?.[this.form.model]?.[this.form.variant] || []
        this.batterysizes = Array.isArray(variantData) ? variantData : [variantData]
        this.form.batterysize = ''
      }
    },
    getSelectedVehicle () {
      return {
        manufacturer: this.form.manufacturer,
        model: this.form.model,
        variant: this.form.variant,
        batterysize: this.form.batterysize
      }
    }
  },
  mounted () {
    // Fahrzeugoptionen laden, wenn die Komponente gemountet ist
    this.loadVehicles()
  }
}
</script>
